import React, { useState, useEffect } from "react";
import RingLoader from "../components/RingLoader";
import {
  trays,
  chairs,
  neons,
  sunumluklar,
  columns,
  sehpalar,
  mumluklar,
  shamdanlar,
  benchler,
  vazolar,
  pastastandlari,
  suplalar,
  Halılar,
  Işıklar
} from "../data/itemsList";
import "./Items.css";
import { useNavigate } from "react-router-dom";

function Items() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("trays");
  const [modalImage, setModalImage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadedCount, setLoadedCount] = useState(0);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setIsLoading(true);
    setLoadedCount(0);
    console.log("👉 Kategori değişti:", category);
  };

  const getItemsByCategory = () => {
    switch (selectedCategory) {
      case "trays": return trays;
      case "chairs": return chairs;
      case "neons": return neons;
      case "sunumluklar": return sunumluklar;
      case "columns": return columns;
      case "sehpalar": return sehpalar;
      case "mumluklar": return mumluklar;
      case "shamdanlar": return shamdanlar;
      case "benchler": return benchler;
      case "vazolar": return vazolar;
      case "pastastandlari": return pastastandlari;
      case "suplalar": return suplalar;
      case "Halılar": return Halılar;
      case "Işıklar": return Işıklar;
      default: return [];
    }
  };

  const itemsToShow = getItemsByCategory();

  useEffect(() => {
    setLoadedCount(0);

    // 👇 Mobilde içerik yüklenmesini tetikle
    setTimeout(() => {
      window.scrollBy(0, 1);
    }, 50);
  }, [selectedCategory]);

  useEffect(() => {
    if (
      (itemsToShow.length > 0 && loadedCount >= itemsToShow.length) ||
      itemsToShow.length === 0
    ) {
      setIsLoading(false);
    }
  }, [loadedCount, itemsToShow]);

  return (
    <div className="items-container">
      <button onClick={() => navigate(-1)} className="back-button">
        ◀ Geri Dön
      </button>

      <div className="category-tabs">
        {[
          ["trays", "Tepsiler"],
          ["chairs", "Sandalyeler"],
          ["neons", "Neonlar"],
          ["sunumluklar", "Sunumluklar"],
          ["columns", "Sütunlar"],
          ["sehpalar", "Sehpalar"],
          ["mumluklar", "Mumluklar"],
          ["shamdanlar", "Şamdanlar"],
          ["benchler", "Benchler"],
          ["vazolar", "Vazolar"],
          ["pastastandlari", "Pasta Standları"],
          ["suplalar", "Suplalar"],
          ["Halılar", "Halılar"],
          ["Işıklar", "Işıklar"]
        ].map(([key, label]) => (
          <button
            key={key}
            className={selectedCategory === key ? "active" : ""}
            onClick={() => handleCategoryClick(key)}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="tray-grid-wrapper">
        {isLoading && <RingLoader />}
        <div
          className="tray-grid"
          style={{
            opacity: isLoading ? 0 : 1,
          }}
        >
          {itemsToShow.map((item, index) => (
            <div
              key={index}
              className="tray-card"
              onClick={() => setModalImage(item.image)}
            >
              <img
                src={item.image}
                alt={item.name}
                loading="lazy"
                onLoad={() => setLoadedCount((prev) => prev + 1)}
                onError={() => setLoadedCount((prev) => prev + 1)}
              />
              <h3>{item.name}</h3>
            </div>
          ))}
        </div>
      </div>

      {modalImage && (
        <div className="modal" onClick={() => setModalImage(null)}>
          <img className="modal-image" src={modalImage} alt="Büyük Görsel" />
        </div>
      )}
    </div>
  );
}

export default Items;
